export const SET_IS_ON_LINK = "set_is_on_link";
